import { accAdd } from '../utils/dataUtils';

export function formatListData(
  data: any[],
  params: any,
  subDataKey: string,
  rowKey?: string | ((record: any) => string),
  subRowKey?: string | ((record: any) => string),
): any[] {
  data.forEach((item, index) => {
    item.isMainTable = true;
    if (rowKey) {
      if (typeof rowKey === 'string') {
        item.key = item[rowKey];
      } else {
        item.key = rowKey(item);
      }
    } else {
      const newKey = String((((params.page - 1) * params.pageSize) | 0) + index);
      item.key = newKey;
    }
    formatChildren(item, item.key, subDataKey, subRowKey);
  });
  return data;
}

export function formatChildren(
  data: any,
  parentKey: string,
  subDataKey: string = 'children',
  subRowKey?: string | ((record: any) => string),
) {
  const children = data[subDataKey];
  if (Array.isArray(children) && children.length) {
    const childrenData: any[] = children;
    childrenData.forEach((childrenItem, childrenKey) => {
      childrenItem.parentKey = parentKey;
      if (subRowKey) {
        if (typeof subRowKey === 'string') {
          childrenItem.key = childrenItem[subRowKey];
        } else {
          childrenItem.key = subRowKey(childrenItem);
        }
      } else {
        childrenItem.key = `${parentKey}-${childrenKey}`;
      }
      const nextChildren = childrenItem[subDataKey];
      if (Array.isArray(nextChildren) && nextChildren.length)
        formatChildren(childrenItem, childrenItem.key, subDataKey, subRowKey);
    });
    if (subDataKey !== 'children') {
      // delete data[subDataKey];
      data.children = childrenData;
    }
  }
}
export function getParentKeys(data: any[]): string[] {
  const keys: string[] = [];
  data.forEach(item => {
    const children = item.children;
    if (Array.isArray(children) && children.length) {
      keys.push(item.key, ...getParentKeys(children));
    }
  });
  return keys;
}
/** 分组合计 */
export function getGroupTotal(groupTotal: string[], childrenData: any[]) {
  const result: any = {};
  if (groupTotal.length && childrenData.length) {
    childrenData.forEach(children => {
      groupTotal.forEach(item => {
        result[item] = accAdd(result[item] || 0, children[item]);
      });
    });
  }
  return result;
}

/** 分组 */
export function formatGroupList(data: any[], groupKeys: string | string[], params: any, rowKey?: string | ((record: any) => string)): any[] {
  const dataSource: any[] = [];
  if (Array.isArray(data) && data.length) {
    const groupList: any = {};
    data.forEach(item => {
      const objKey = getGroupKey(item, groupKeys);
      if (!groupList[objKey]) groupList[objKey] = [];
      groupList[objKey].push(item);
    });
    const newKey: number = ((params.page - 1) * params.pageSize) | 0;
    for (let [key, value] of Object.entries(groupList)) {
      const mainRecord: any = JSON.parse(key);
      const mainKey: string = String(newKey + dataSource.length);
      const children: any[] = [];
      if (Array.isArray(value) && value.length) {
        value.forEach((item, index) => {
          let childrenKey: any = '';
          if (rowKey) {
            if (typeof rowKey === 'string') {
              childrenKey = item[rowKey];
            } else {
              childrenKey = rowKey(item);
            }
          } else {
            childrenKey = index;
          }
          children.push({
            key: `${mainKey}-${childrenKey}`,
            ...item,
          })
        });
      }
      dataSource.push({
        ...mainRecord,
        children,
        key: mainKey,
        isMainTable: true,
      });
    }
  }
  return dataSource;
}

/**
 * 生成分组行key
 * @param record 行数据
 * @param groupKeys 标识行数据的字段集合
 * @returns 
 */
export function getGroupKey(record: any, groupKeys: string | string[]): string {
  const groupKey: any = {};
  if (typeof groupKeys === 'string') {
    groupKey[groupKeys] = record[groupKeys];
  } else {
    groupKeys.forEach(item => {
      groupKey[item] = record[item];
    });
  }
  return JSON.stringify(groupKey);
}
